import {
  getSettlementUnits,
  updateSettlementUnit,
  deleteSettlementUnit,
} from '@/api/settlementUnit';
import { AccountModule } from '@/store/modules/account';
import { generateUUID } from '@/utils/other';
import moment from 'moment';

type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;
type IUpdateSettlementUnit = ISettlementUnit.IRequest.IUpdateSettlementUnit;


class SettlementUnitManage {
  private $data: ISettlementUnitInfo[] = [];
  get data() {
    return this.$data;
  }
  public requestGetSettlementUnits(): Promise<string> {
    return new Promise((resolve, reject) => {
      getSettlementUnits()
        .then((res) => {
          this.$data = res.data;
          resolve(res.message);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  }
  public requestUpdateSettlementUnit(
    settlementUnit: IUpdateSettlementUnit,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      updateSettlementUnit(settlementUnit)
        .then((res) => {
          resolve(res.message);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  }
  public requestDeleteSettlementUnit(settlementUnitId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      deleteSettlementUnit(settlementUnitId)
        .then((res) => {
          this.deleteSettlementUnit(settlementUnitId);
          resolve(res.message);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  }
  public changeSettlementUnit(settlementUnit: ISettlementUnitInfo) {
    for (let i = 0; i < this.$data.length; i++) {
      if (this.$data[i].id === settlementUnit.id) {
        this.$data[i] = { ...settlementUnit };
        break;
      }
    }
  }
  public createSettlementUnit(): ISettlementUnitInfo {
    return {
      id: generateUUID(),
      name: '',
      active: true,
      createdOn: '',
      createdBy: AccountModule.userDetailInfo?.id || '',
      createdName: AccountModule.name,
    };
  }
  public addSettlementUnit(settlementUnit: ISettlementUnitInfo) {
    settlementUnit.createdOn = settlementUnit.createdOn || moment().toJSON();
    this.$data.unshift(settlementUnit);
  }
  public deleteSettlementUnit(settlementUnitId: string) {
    const index = this.$data.findIndex(
      (todoType) => todoType.id === settlementUnitId,
    );
    this.$data.splice(index, 1);
  }
}
export const settlementUnitManage = new SettlementUnitManage();
